import { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { Loader2 } from 'lucide-react';
import type { ProjetoT } from '@/types';

// Diálogo genérico "Atrelar a um projeto" — reaproveitado no card de Fluxograma e de Organograma
// pra vincular o registro (não um nó do canvas) a um ProjetoT.
export function AtrelarProjetoDialog({
  open,
  onOpenChange,
  projetos,
  currentId,
  onConfirm,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  projetos: ProjetoT[];
  currentId: string | null | undefined;
  onConfirm: (projetotId: string | null) => Promise<void>;
}) {
  const [selecionado, setSelecionado] = useState(currentId || 'none');
  const [salvando, setSalvando] = useState(false);

  useEffect(() => {
    if (open) setSelecionado(currentId || 'none');
  }, [open, currentId]);

  const handleSalvar = async () => {
    setSalvando(true);
    try {
      await onConfirm(selecionado === 'none' ? null : selecionado);
      onOpenChange(false);
    } finally {
      setSalvando(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm" onClick={(e) => e.stopPropagation()}>
        <DialogHeader>
          <DialogTitle>Atrelar a um projeto</DialogTitle>
          <DialogDescription>Vincule este item a um projeto.</DialogDescription>
        </DialogHeader>
        <Select value={selecionado} onValueChange={setSelecionado}>
          <SelectTrigger>
            <SelectValue placeholder="Selecione um projeto" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="none">Sem vínculo</SelectItem>
            {projetos.map((p) => (
              <SelectItem key={p.id} value={p.id}>{p.titulo}</SelectItem>
            ))}
          </SelectContent>
        </Select>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} disabled={salvando}>Cancelar</Button>
          <Button onClick={handleSalvar} disabled={salvando}>
            {salvando ? <Loader2 className="h-4 w-4 animate-spin mr-2" /> : null}
            Salvar
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
